import { render, staticRenderFns } from "./ExpenseTypes.vue?vue&type=template&id=f6d2bb42&scoped=true&"
import script from "./ExpenseTypes.vue?vue&type=script&lang=js&"
export * from "./ExpenseTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d2bb42",
  null
  
)

export default component.exports